
<script>
import http from '@/service/http'
import { mapState } from 'vuex'
export default {
  name: 'Form',
  data () {
    return {
      categorias: [],
      contas: [],
      formas: [],
      vencimento: false,
      cliente: {
        cliente: ''
      },
      conta: {
        id: '',
        categoria_id: '',
        os_id: '',
        orcamento_id: '',
        conta_id: '',
        forma_id: '',
        cliente_id: '',
        descricao: '',
        observacoes: '',
        parcelas: []
      },
      os: {
        valor: 0,
        proposta: {
          pagamento: {
            pagamento: ''
          }
        }
      }
    }
  },
  mounted () {
    this.fecth()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id != null) {
        this.fecth()
      }
    }
  },
  methods: {
    async fecth () {
      this.clear()
      const { id } = this.$route.params
      const { data } = await http.get(`/financeiro/receber/${id}/os`)
      this.os = data.os
      this.conta.os_id = data.os.id
      this.conta.orcamento_id = data.os.orcamento_id
      this.conta.cliente_id = data.os.cliente_id
      this.conta.forma_id = (data.os && data.os.proposta && data.os.proposta.pagamento) ? data.os.proposta.pagamento.forma_id : ''
      this.conta.descricao = 'Faturamento OS #' + data.os.id
      this.conta.categoria_id = 76
      this.categorias = data.categorias
      this.contas = data.contas
      this.formas = data.formas
      this.cliente = data.os.cliente
      this.conta.parcelas = data.parcelas
      setTimeout(function () {
        window.Materialize.updateTextFields()
      }, 0)
    },
    validate () {
      this.$validator.validateAll().then(success => {
        if (!success) {
          this.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          })
          return false
        } else {
          this.submit()
        }
      })
    },
    async submit () {
      const verb = 'post'
      const url = '/financeiro/receber/os'
      const { data } = await http[verb](url, this.conta)
      if (data != null) {
        this.$emit('update-financeiro-receber-list', { conta: data.conta })
        this.$router.push({ name: 'os.form', params: { id: this.conta.os_id } })
      }
    },
    clear () {
      this.conta = {
        id: '',
        categoria_id: '',
        os_id: '',
        orcamento_id: '',
        conta_id: '',
        forma_id: '',
        cliente_id: '',
        descricao: '',
        observacoes: '',
        parcelas: []
      }
    },
    destroyParcela (index) {
      this.$swal({
        title: 'Atenção',
        text: `excluir uma Parcela é uma operação irreversível`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(() => {
        this.conta.parcelas.splice(index, 1)
        window.Materialize.toast('Parcela excluída!', 4000)
      })
    },
    addParcela () {
      this.conta.parcelas.push({vencimento: '', valor: ''})
    }
  },
  computed: {
    ...mapState(['loading']),
    valorTotal () {
      let valor = 0
      if (this.conta.parcelas.length > 0) {
        this.conta.parcelas.forEach((item) => {
          if (item.valor) {
            valor += parseFloat(item.valor)
          }
        })
      }
      return parseFloat(valor)
    },
    pagamentoLabel () {
      return (this.os && this.os.proposta && this.os.proposta.pagamento) ? this.os.proposta.pagamento.pagamento : '-'
    }
  }
}
</script>

<template>
  <div>

    <form>

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div class="row">
            <div class="input-field col s12 m4">
              <input type="text" disabled v-model="cliente.cliente">
              <label>Cliente</label>
            </div>
            <div class="input-field col s12 m2">
              <input type="text" disabled v-model="conta.os_id">
              <label for="descricao">#OS</label>
            </div>

            <div class="input-field col s12 m2">
              <input type="text" disabled v-model="os.valor">
              <label>R$</label>
            </div>

            <div class="input-field col s12 m4">
              <input type="text" disabled v-model="pagamentoLabel">
              <label>Forma de Pagamento</label>
            </div>

          </div>

          <div class="row">
            <div class="input-field col s12 m8">
              <input name="descricao" id="descricao" type="text" v-validate data-vv-rules="required" :class="{invalid: errors.has('descricao')}" v-model="conta.descricao">
              <label for="descricao">*Descrição</label>
              <small class="red-text">{{ errors.first('descricao') }}</small>
            </div>
            <div class="col s12 m4">
              <label for="categoria_id">*Categoria</label>
              <select name="categoria_id" id="categoria_id" v-validate data-vv-rules="required" :class="{invalid: errors.has('categoria_id')}" v-model="conta.categoria_id">
                <option v-for="categoria in categorias" :value="categoria.id">{{ categoria.categoria }}</option>
              </select>
              <small class="red-text">{{ errors.first('categoria_id') }}</small>
            </div>
          </div>

          <div class="row">
            <div class="col s12 m3">
              <label for="conta_id">*Conta</label>
              <select name="conta_id" id="conta_id" v-validate data-vv-rules="required" :class="{invalid: errors.has('conta_id')}" v-model="conta.conta_id">
                <option v-for="conta in contas" :value="conta.id">{{ conta.conta }}</option>
              </select>
              <small class="red-text">{{ errors.first('conta_id') }}</small>
            </div>
            <div class="col s12 m3">
              <label for="forma_id">*Forma de Pagamento</label>
              <select name="forma_id" id="forma_id" v-validate data-vv-rules="required" :class="{invalid: errors.has('forma_id')}" v-model="conta.forma_id">
                <option v-for="forma in formas" :value="forma.id">{{ forma.forma }}</option>
              </select>
              <small class="red-text">{{ errors.first('forma_id') }}</small>
            </div>
          </div>

          <div class="row" v-for="(parcela, index) in conta.parcelas">

            <div class="input-field col s12 m3">
              <i class="material-icons prefix">event</i>
              <input name="vencimento" :id="`icon_vencimento${index}`" type="date" v-validate data-vv-rules="required" :class="{invalid: errors.has('vencimento' + index)}" v-model="parcela.vencimento" :data-value="parcela.vencimento">
              <label :for="`icon_vencimento${index}`"></label>
              <small class="red-text">{{ errors.first('vencimento'+index) }}</small>
            </div>
            <div class="input-field col s12 m3">
              <input name="valor" id="valor" type="number" step="any" min="0" v-validate data-vv-rules="required" :class="{invalid: errors.has('valor'+index)}" v-model="parcela.valor">
              <label for="valor">*Valor</label>
              <small class="red-text">{{ errors.first('valor'+index) }}</small>
            </div>
            <div class="input-field col s12 m1">
              <br />
              <a href="#" @click.prevent="destroyParcela(index)">
                <i class="material-icons red-text">delete_forever</i>
              </a>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <button type="button" class="waves-effect waves-light btn" @click.prevent="addParcela()">Adicionar Parcela</button>
            </div>

          </div>

          <div class="row" v-show="parseFloat(os.valor) !== valorTotal">

            <div class="input-field col s12">
              <span class="red-text">Valor total das parcelas <strong>R$ {{ valorTotal }}</strong> não corresponde com o valor da OS <strong>R$ {{ os.valor }}</strong></span>
            </div>

          </div>

          <div class="row" v-show="parseFloat(os.valor) > valorTotal">

            <div class="input-field col s12">
              <span class="red-text">Pendente <strong>R$ {{ parseFloat(os.valor) - valorTotal }}</strong></span>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <button class="waves-effect waves-light btn" :disabled="loading || parseFloat(os.valor) !== valorTotal" @click.prevent="validate">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/financeiro/receber/formOs.vue